import { COLOMBIA_IDEAM_SOURCE_KEY } from "./colombiaIdeamRadar.js";
import { COLOMBIA_RAINVIEWER_SOURCE_KEY } from "./colombiaRainViewerRadar.js";
import { IDEAM_BART_COMPOSITE_SOURCE_KEY } from "./ideamBartRadarOverlay.js";
import {
  SIATA_SANTA_ELENA_RADAR_SOURCE_CODE,
  SIATA_SANTA_ELENA_RADAR_SOURCE_KEY,
} from "./siataSantaElenaRadar.js";

/** Persisted / UI source mode values (cookie + selector). */
export const RADAR_SOURCE_MODE_INPUT = {
  PREFERRED: "preferred",
  IDEAM_BART: "ideam_bart",
  /** @deprecated Migrated to IDEAM_BART — legacy OSPA-only alias */
  IDEAM_LEGACY_ALIAS: "ideam",
  RAINVIEWER: "rainviewer",
  LEGACY_OSPA: "legacy_ideam_ospa",
  VALLEY_PREFERRED: "valley_preferred",
  SIATA_LOCAL_ONLY: "siata_local_only",
};

export const PERSISTED_RADAR_SOURCE_MODES = new Set([
  RADAR_SOURCE_MODE_INPUT.PREFERRED,
  RADAR_SOURCE_MODE_INPUT.IDEAM_BART,
  RADAR_SOURCE_MODE_INPUT.IDEAM_LEGACY_ALIAS,
  RADAR_SOURCE_MODE_INPUT.RAINVIEWER,
  RADAR_SOURCE_MODE_INPUT.LEGACY_OSPA,
  RADAR_SOURCE_MODE_INPUT.VALLEY_PREFERRED,
  RADAR_SOURCE_MODE_INPUT.SIATA_LOCAL_ONLY,
]);

/** Normalized source mode values used in selection logic and diagnostics. */
export const NORMALIZED_RADAR_SOURCE_MODES = {
  PREFERRED: "preferred",
  IDEAM_BART_ONLY: "ideam_bart_only",
  RAINVIEWER_ONLY: "rainviewer_only",
  LEGACY_IDEAM_OSPA: "legacy_ideam_ospa",
  VALLEY_PREFERRED: "valley_preferred",
  SIATA_LOCAL_ONLY: "siata_local_only",
};

/** Normalized rendered/selected source keys. */
export const NORMALIZED_RADAR_SOURCES = {
  IDEAM_BART: "ideam_bart_composite",
  RAINVIEWER: "rainviewer",
  IDEAM_OSPA: "ideam_ospa",
  SIATA_SANTA_ELENA: "siata_santa_elena",
  NONE: "none",
};

export const RADAR_SOURCE_API_KEYS = {
  IDEAM_BART: IDEAM_BART_COMPOSITE_SOURCE_KEY,
  IDEAM_OSPA: COLOMBIA_IDEAM_SOURCE_KEY,
  RAINVIEWER: COLOMBIA_RAINVIEWER_SOURCE_KEY,
  SIATA_SANTA_ELENA: SIATA_SANTA_ELENA_RADAR_SOURCE_KEY,
  NONE: "none",
};

export const RADAR_SOURCE_DISPLAY_LABELS = {
  [NORMALIZED_RADAR_SOURCES.IDEAM_BART]: "IDEAM Imagen Compuesta",
  [NORMALIZED_RADAR_SOURCES.RAINVIEWER]: "RainViewer backup",
  [NORMALIZED_RADAR_SOURCES.IDEAM_OSPA]: "Legacy IDEAM OSPA",
  [NORMALIZED_RADAR_SOURCES.SIATA_SANTA_ELENA]: "SIATA Santa Elena Radar",
  [NORMALIZED_RADAR_SOURCES.NONE]: "No radar source",
};

export const RADAR_SOURCE_TRUST_LABELS = {
  [NORMALIZED_RADAR_SOURCES.IDEAM_BART]: "Official",
  [NORMALIZED_RADAR_SOURCES.RAINVIEWER]: "Backup",
  [NORMALIZED_RADAR_SOURCES.IDEAM_OSPA]: "Official / Legacy",
  [NORMALIZED_RADAR_SOURCES.SIATA_SANTA_ELENA]: "Local official",
  [NORMALIZED_RADAR_SOURCES.NONE]: "Unavailable",
};

export const RADAR_SOURCE_MODE_LABELS = {
  [RADAR_SOURCE_MODE_INPUT.PREFERRED]: "Preferred: IDEAM official + fallback",
  [RADAR_SOURCE_MODE_INPUT.IDEAM_BART]: "IDEAM official only",
  [RADAR_SOURCE_MODE_INPUT.RAINVIEWER]: "RainViewer backup only",
  [RADAR_SOURCE_MODE_INPUT.LEGACY_OSPA]: "Legacy IDEAM OSPA diagnostic",
  [RADAR_SOURCE_MODE_INPUT.VALLEY_PREFERRED]: "Valley Preferred",
  [RADAR_SOURCE_MODE_INPUT.SIATA_LOCAL_ONLY]: "SIATA local only",
};

export const RADAR_SOURCE_MODE_DESCRIPTIONS = {
  [RADAR_SOURCE_MODE_INPUT.VALLEY_PREFERRED]:
    "Use SIATA local radar in the Aburrá Valley when available, then IDEAM official radar, then RainViewer backup.",
  [RADAR_SOURCE_MODE_INPUT.SIATA_LOCAL_ONLY]:
    "Use SIATA Santa Elena Radar only. No automatic fallback.",
};

export const SIATA_RADAR_SOURCE_MODE_OPTIONS = [
  {
    value: RADAR_SOURCE_MODE_INPUT.VALLEY_PREFERRED,
    label: RADAR_SOURCE_MODE_LABELS.valley_preferred,
    fullLabel: `Valley Preferred: ${RADAR_SOURCE_MODE_DESCRIPTIONS.valley_preferred}`,
  },
  {
    value: RADAR_SOURCE_MODE_INPUT.SIATA_LOCAL_ONLY,
    label: RADAR_SOURCE_MODE_LABELS.siata_local_only,
    fullLabel: `SIATA local only: ${RADAR_SOURCE_MODE_DESCRIPTIONS.siata_local_only}`,
  },
];

export const SIATA_RADAR_SOURCE_CODE = SIATA_SANTA_ELENA_RADAR_SOURCE_CODE;

/** BART frames older than this are stale but may still render in preferred/BART-only modes. */
export const IDEAM_BART_STALE_THRESHOLD_MINUTES = 45;

export const ESSENTIAL_RADAR_SOURCE_MODE_OPTIONS = [
  {
    value: RADAR_SOURCE_MODE_INPUT.PREFERRED,
    label: RADAR_SOURCE_MODE_LABELS.preferred,
    fullLabel: "Preferred: IDEAM official composite with RainViewer fallback",
  },
  {
    value: RADAR_SOURCE_MODE_INPUT.IDEAM_BART,
    label: "IDEAM official only",
    fullLabel: "IDEAM official composite only (no RainViewer fallback)",
  },
  {
    value: RADAR_SOURCE_MODE_INPUT.RAINVIEWER,
    label: RADAR_SOURCE_MODE_LABELS.rainviewer,
    fullLabel: "RainViewer Colombia backup only",
  },
];

export const LEGACY_RADAR_SOURCE_MODE_OPTION = {
  value: RADAR_SOURCE_MODE_INPUT.LEGACY_OSPA,
  label: RADAR_SOURCE_MODE_LABELS.legacy_ideam_ospa,
  fullLabel: "Legacy IDEAM OSPA diagnostic (Analyst Tools only)",
};
